// src/components/ScrollLink.tsx
import React from "react"
import {Link, navigate} from "gatsby"
import {getHeaderHeight} from "../utils/getHeaderHeight"

interface ScrollLinkProps {
	name: string
	className?: string
	onMouseEnter?: (event: React.MouseEvent<HTMLAnchorElement>) => void
	onMouseLeave?: () => void
	onClick?: () => void
}

const ScrollLink: React.FC<ScrollLinkProps> = ({
	name,
	className,
	onMouseEnter,
	onMouseLeave,
	onClick,
}) => {
	/* LEFT OFF HERE -- WHEN NOT ON HOME, SHOULD IT USE SCROLL LINK OR REGULAR LINKS SO IT USES /#slug and not scroll??
or is that already handled with the <Link below??>
*/

	const slug = name.toLowerCase()
	const to = `#${slug}`
	const url = `/${to}`
	const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
		const target = document.querySelector(to)
		if (target) {
			e.preventDefault()
			const headerHeight = getHeaderHeight()
			const targetPosition =
				target.getBoundingClientRect().top +
				window.pageYOffset -
				headerHeight +
				1 // Not sure why this is off by 1px but was needed to make this work

			window.scrollTo({
				top: slug == "home" ? 0 : targetPosition,
				behavior: "smooth",
			})
			if (onClick) onClick()
		} // else navigate(to)
	}

	return (
		<Link
			to={url}
			onClick={handleClick}
			className={className}
			onMouseEnter={onMouseEnter}
			onMouseLeave={onMouseLeave}
		>
			{name}
		</Link>
	)
}

export default ScrollLink
